import { docodeHexResponse } from "../../_common/common.utils";
import RpcNonResponseTypes from "./rpcNonReport.types";
const INITIAL_STATE: any = {
  rpcNonReportFetchArr: [],
  rpcNonReportFetchResponse: null,
  rpcNonReportCampaignArr: [],
  rpcNonReportCampaignResponse: null,
  rpcNonReportExportArr: [],
  rpcNonReportExportResponse: null,
  exportrpcNonReportStatus: "",
};
const rpcNonResponseReducer = (state = INITIAL_STATE, action: any) => {
  switch (action.type) {
    case RpcNonResponseTypes.RPC_NON_REPORT_LIST_SUCCESS:
      return {
        ...state,
        rpcNonReportFetchResponse: action.payload,
        rpcNonReportFetchArr: docodeHexResponse(action.payload, "RPCReportKey"),
      };

    case RpcNonResponseTypes.RPC_NON_REPORT_LIST_FAILURE:
      return {
        ...state,
        rpcNonReportFetchResponse: action.payload,
        rpcNonReportFetchArr: [],
      };

    case RpcNonResponseTypes.RPC_NON_REPORT_LIST_CHANGED:
      return { ...state, rpcNonReportFetchResponse: null };

    case RpcNonResponseTypes.RPC_NON_REPORT_CAMPAIGN_SUCCESS:
      return {
        ...state,
        rpcNonReportCampaignResponse: action.payload,
        rpcNonReportCampaignArr: docodeHexResponse(
          action.payload,
          "FetchRPCReportCampaignKey",
        ),
      };

    case RpcNonResponseTypes.RPC_NON_REPORT_CAMPAIGN_FAILURE:
      return {
        ...state,
        rpcNonReportCampaignResponse: action.payload,
        rpcNonReportCampaignArr: [],
      };

    case RpcNonResponseTypes.RPC_NON_REPORT_CAMPAIGN_CHANGED:
      return { ...state, rpcNonReportCampaignResponse: null };

    case RpcNonResponseTypes.RPC_NON_REPORT_EXPORT_SUCCESS:
      return {
        ...state,
        rpcNonReportExportResponse: action.payload,
        rpcNonReportExportArr: docodeHexResponse(
          action.payload,
          "CreateRequestReportKey",
        ),
        exportrpcNonReportStatus: "Success",
      };

    case RpcNonResponseTypes.RPC_NON_REPORT_EXPORT_FAILURE:
      return {
        ...state,
        rpcNonReportExportResponse: action.payload,
        rpcNonReportExportArr: [],
        exportrpcNonReportStatus: "Failure",
      };

    case RpcNonResponseTypes.RPC_NON_REPORT_EXPORT_CHANGED:
      return {
        ...state,
        rpcNonReportExportResponse: null,
        exportrpcNonReportStatus: "",
      };

    default:
      return state;
  }
};
export default rpcNonResponseReducer;
